export const FEE_GROUPS = {
    downloadPrice: ["protocol"],
    runPrice: ["hosting"]
};